export const formConfig = (tenant) => {
  return [
    {label: 'Name', value: tenant, disabled: true, map: 'friendly_name', validateEmail: false},
    {
      label: "Monthly Reporting Email Address",
      value: "",
      disabled: false,
      map: 'monthly_report_emails',
      validateEmail: true
    },
    {
      label: "Weekly Reporting Email Address",
      value: "",
      disabled: false,
      map: 'weekly_report_emails',
      validateEmail: true
    }
  ];
};

export const tooltipConfig = {
  'Monthly Reporting Email Address': 'Monthly Reporting Email address: Enter up to 3 comma-separated email addresses ' +
    '(preferably a distribution list) to receive Monthly Reports',
  'Weekly Reporting Email Address': (<><p>Weekly Reporting Email address:Enter up to 3 comma-separated email addresses
    (preferably a distribution list) to receive Weekly Executive Reports.</p>
    <p>Note: Available only for customers with a <b><i>WatchGuard Core MDR license</i></b>.</p></>)
}
